var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 532,
    viewBox: "0 0 117 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 66.5c-0.0066 31.01 24.99 56.23 56 56.49v20c-31.2 0-56.5 25.3-56.5 56.5s25.3 56.5 56.5 56.5v20c-31.2 0-56.5 25.3-56.5 56.5s25.3 56.5 56.5 56.5v20c-31.2 0-56.5 25.3-56.5 56.5s29.03 55.73 56.5 56.5v10.01h-81v-532h81v9.99c-31.02 0.143-56.01 25.49-56 56.51z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 67,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 200,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 333,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 466,
    r: 35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.f4d9ffd61394bea8e423201414ac4115.svg";
export { ForwardRef as ReactComponent };